/* "Goes well with" row in the cart drawer: Shopify product recommendations for the first cart item,
   with a + button that adds the first available variant and re-renders the drawer. */
if (!customElements.get('lt-cart-recs')) {
  customElements.define('lt-cart-recs', class LtCartRecs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      const exclude = (this.dataset.exclude || '').split(',');
      const url = `${this.dataset.url}.json?product_id=${this.dataset.productId}&limit=8&intent=related`;
      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          const items = (data.products || []).filter((p) => p.available && !exclude.includes(String(p.id))).slice(0, 6);
          if (!items.length) return;
          const fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' });
          const list = this.querySelector('.lt-cart-recs__list');
          list.innerHTML = items.map((p) => {
            const v = p.variants.find((x) => x.available) || p.variants[0];
            const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=120` : '';
            const title = p.title.replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));
            return `<li class="lt-cart-recs__card">
              <a class="lt-cart-recs__media" href="${p.url}" tabindex="-1" aria-hidden="true">${img ? `<img src="${img}" alt="" width="56" height="56" loading="lazy">` : ''}</a>
              <a class="lt-cart-recs__name" href="${p.url}">${title}</a>
              <span class="lt-cart-recs__price">${fmt.format(v.price / 100)}${v.compare_at_price > v.price ? `<s>${fmt.format(v.compare_at_price / 100)}</s>` : ''}</span>
              <button type="button" class="lt-cart-recs__add" data-variant="${v.id}" aria-label="Add ${title} to cart">+</button>
            </li>`;
          }).join('');
          this.hidden = false;
          list.addEventListener('click', (e) => this.onAdd(e));
        })
        .catch(() => {});
    }

    onAdd(e) {
      const btn = e.target.closest('.lt-cart-recs__add');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      const drawer = document.querySelector('cart-drawer');
      fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      })
        .then((r) => r.json())
        .then((state) => {
          if (drawer && state.sections) {
            state.id = btn.dataset.variant;
            drawer.renderContents(state);
          } else {
            window.location.href = window.routes ? window.routes.cart_url : '/cart';
          }
        })
        .catch(() => { btn.disabled = false; });
    }
  });
}
